import React, { useState, useEffect, useRef } from 'react'
import './invoice.css';
import Hdr from '../shared/Hdr';
//import { apiPath1} from "../services/apiConfig";
import { useReactToPrint } from 'react-to-print';
import LoadingModal from './Loading'


function Invoice(props) {

 //alert('invoice')
 
  const [loading, setLoading] = useState(false);
  const [invoiceData3, setInvoiceData3] = useState([])
  const token = localStorage.getItem('token');
  const {data} = props
  //const [displayInvoice, setDisplayInvoice] = useState('none')

  const contentRef = useRef();  

    const generatePDF = useReactToPrint({
      // onBeforePrint : ()=>alert('start'),
      // content: () => componentPDF.current,
        contentRef
      
      // onAfterPrint : ()=>alert('End of Print')
  
    })
    

  //   const componentPDF = useRef();

    useEffect(() => {
      getInvoice()
    },[data])

  const invoiceData = {

    consignor : 'ENERGY PLUS POWER SERVICES PVT LTD',
    cadd1 : '7, AVENUE EAST, MORDER PARK',
    cadd2 : 'SANTOSHPUR, JADAVPUR, KOLKATA - 700 075',
    cadd3 : 'GSTN: 19AACCE2180L1ZH',

    consigneeadd: 'BECIS SUSTAINABLE ENERGY INDIA PROVATE LIMITED, Ward No. 06, Nabapally sub Post Office, Nabapally Circular Road, Barasat, Nothe Twentyfour Parganas, West Bengal 700016',  
   
    //challanNo :'EPPS/RC/BECIS/25-26/06',
    //challanDt :'02/05/2025',
    orderNo :'BECIS/04/25-26',
    orderDt :'03/03/2025',

    deliveryadd: 'BASIS SUSTAINABLE ENERGY INDIA PRIVATE LIMITED, Neelgunj, C O Keventer Agro Limited – Dairy Plant, Barasat, Subhasnagar, Nilganj Road, Bandipur, North Twenty Four Parganas, West Bengal, 700121',
    
    items1: [
      { srl: '1', description: 'Safety Belt', size : '', uom: 'Nos.', quantity: 8, Remarks: 'NOT FOR SALE' },
      { srl: '2', description: 'First Aid Box', size : '', uom: 'Nos.', quantity: 1, Remarks: 'NOT FOR SALE' },
      { srl: '3', description: 'Heat resistant Hand gloves', size : 'Large', uom: 'pair.', quantity: 20, Remarks: 'NOT FOR SALE' }, 
    ],  

  };

  const [challanNo, setChallanNo] = useState()
  const [challanDt, setChallanDt] = useState()
  //const [items,setItems] = useState([])

  function getInvoice(){

    //let jsonString =  JSON.stringify(data)
    //const dataObject = JSON.parse(jsonString);

    if (data.status === true) {
    
   //   console.log('Data Status >'+ data.status)
   //   console.log('Items >'+ data.data.items[0].tool_code)
   //   console.log('Challan >'+ data.data.transaction[0].transaction_code)
   //   console.log('Challan Dt>'+ data.data.transaction[0].transaction_date.substring(0, 10))

      setChallanNo( data.data.transaction[0].transaction_code)
      setChallanDt( data.data.transaction[0].transaction_date.substring(0, 10))
    
      generatePDF()
    }
    
  }

const [breakCount, setBreakCount] = useState(0)

const ShowItems = ()=>{
  if (data.status === true){
    setBreakCount(13 - data.data.items.length)
    setLoading(false)
    return(<>
      {data.data.items.map((item, index) => (
        <tr key={index}>
          <td>{index+1}</td> 
          <td>{item.tool_name}</td>
          <td>{item.tool_description}</td>
          <td>{item.uom}</td>
          <td>{item.quantity}</td>
          <td>NOT FOR SALE</td>
        </tr>
      ))}
    </>)
    }
  else{
    setLoading(true)
    return(<>
      <LoadingModal show={loading} />
    </>)

  }

  
}

const HeaderSection = ()=>{
  return(
    <>
      <div>New Page</div>
    </>
    )
  }

const ContentSection = ()=>{
  return(
    <>
      <div>
        <table className="invoice-table" id="innerTable">
          <thead id="innerHeader">
            <tr>
              <th><h5>srl</h5></th>
              <th><h5>Description</h5></th>
              <th><h5>Size</h5></th>
              <th><h5>UOM</h5></th>
              <th><h5>Quantity</h5></th>
              <th><h5>Remarks</h5></th>
            </tr>
          </thead>

          <tbody>
            <ShowItems />
          </tbody>
        
        </table>     
      </div>
    </>
    )
  }

  function MultipleBreaks({ count }) {
    return (
      <>
        {Array.from({ length: count }, (_, index) => (
          <br key={index} />
        ))}
      </>
    );
  }

  return (
  
   <div ref={contentRef} style={{ 'width': '100%' }} >
    <div className="invoice-container" >
      <table className="page-table" id="outerTable">
        <thead id="outerHeader">
          <tr>
            <div className="invoice-header">
              <img alt="" src={require('../asset/images/EP.jpg')} width="40" height="40" style={{'marginBottom': '40px'}} />
              <div className="invoice-details" style={{"alignItems" : "flex-end", "textAlign" : "right"}}>
   
                  <p>MOB(O): (+91) 8335075886</p>
                  <p>KOLKATA - 700 075</p>
                  <p>EMAIL :support@energyplusindia.com</p>
              </div>
            </div>
      
            <div className="invoice-topborder"><h4>Returnable Challan</h4></div>
            <div className="invoice-client">
              <br />
              <h4>CONSIGNOR:</h4>
              <p>{invoiceData.consignor}</p>
              <p>{invoiceData.cadd1}</p>
              <p>{invoiceData.cadd2}</p>
              <p>{invoiceData.cadd3}</p> 

              <p>{invoiceData.cadd3}</p>
              <p>{invoiceData.cadd3}</p>
              <p>{invoiceData.cadd3}</p>
            </div> 
          </tr>
        </thead>
        <tbody >

          <div className="grid-container">
            <div className="grid-item"  >CONSIGNEE</div>
            <div className="grid-item" >
              {invoiceData.consigneeadd} 
            </div>
            <div>
              <div className="grid-item">Returnable Challan No</div>
              <div className="grid-item">Challan Date</div>
              <div className="grid-item">Order Number</div>
              <div className="grid-item">Order Date</div>
            </div>
            <div>
              <div className="grid-item">{challanNo}</div>
              <div className="grid-item">{challanDt}</div>
              <div className="grid-item">{invoiceData.orderNo}</div>
              <div className="grid-item">{invoiceData.orderDt}</div>
            </div>        


            <div className="grid-item"  >DELIVERY ADDRESS</div>
            <div className="grid-item" >
              {invoiceData.deliveryadd} 
            </div>
            <div>
              <div className="grid-item">Ref Packing List No</div>
              <div className="grid-item">Vehicle No.</div>
              <div className="grid-item">CN No</div>
            </div>
            <div>
              <div className="grid-item">-</div>
              <div className="grid-item">-</div>
              <div className="grid-item">-</div>
            </div>        
          </div>
          <br />
          <div className="invoice-topborder" style={{'textAlign':'left','font-size':'20px'}} >Material Details</div><br />

          
          <ContentSection />           
          

          <div className="invoice-summary">Received the above material in good condition</div><br />

          <div className="grid-summary">
            <div className="summary-item">N.B: The materials are going on Returnable Basis. </div><div></div>
            <div className="summary-item">The Sale commercial value of the Material is Nil (Rs 0.0)</div><div></div>
          </div>
          
        <MultipleBreaks count={breakCount} /> 

          <div className="summary-item">Receiver's Signature</div><div></div>
          <div></div><div className="summary-item" style={{'textAlign':'right'}}>For Energy Plus Power Services Pvt Ltd</div>

          <br /><br /><br /><br /><br /><br />
            

          <div className="grid-summary">
            <div className="summary-item">Authorised signatory</div>
            <div className="summary-item" style={{'textAlign':'right'}}>Authorised signatory</div>
          </div>
        </tbody>
      </table>
    </div>   
   
   
    </div>
  
  )
}

export default Invoice;


